<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditSystem()" v-if="permissionList.includes(permission.edit)">{{$t('setting.table_edit')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="editSystem" :title="$t('setting.table_edit')" @ok="editSystem" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editSystemForm" @submit.prevent="editSystem">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_code')}}</template>
                            <label class="from-label">{{ajaxEdit.code}}</label>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting.table_value')}}</template>
                            <b-form-input name="value" v-model="ajaxEdit.value"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {systemAjaxTable,getSystemEdit,systemEdit} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',value:''},
            ajaxAdd:[],
            ajaxEdit:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                edit:'85DF01'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting.table_id'),
                width: '192'
            },{
                prop: "code",
                label: this.$t('setting.table_code'),
                width: '380'
            },{
                prop: "value",
                label: this.$t('setting.table_value'),
                width: '380'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = systemAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.value);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getEditSystem(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSystemEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    if(value.valid){
                        self.preloader(false)
                        self.$bvModal.show('editSystem');
                        self.ajaxEdit = value.data;
                    }else{
                        self.preloader(true)
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editSystem(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.category){
                    this.validate = false;
                    this.errors.push('setting.error_category_empty');
                }
                if(!this.ajaxEdit.code){
                    this.validate = false;
                    this.errors.push('setting.error_code_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editSystemForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = systemEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
